import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLayoutGrid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.5 2.75C3.98122 2.75 2.75 3.98122 2.75 5.5V8.5C2.75 10.0188 3.98122 11.25 5.5 11.25H8.5C10.0188 11.25 11.25 10.0188 11.25 8.5V5.5C11.25 3.98122 10.0188 2.75 8.5 2.75H5.5ZM4.25 5.5C4.25 4.80964 4.80964 4.25 5.5 4.25H8.5C9.19036 4.25 9.75 4.80964 9.75 5.5V8.5C9.75 9.19036 9.19036 9.75 8.5 9.75H5.5C4.80964 9.75 4.25 9.19036 4.25 8.5V5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 2.75C13.9812 2.75 12.75 3.98122 12.75 5.5V8.5C12.75 10.0188 13.9812 11.25 15.5 11.25H18.5C20.0188 11.25 21.25 10.0188 21.25 8.5V5.5C21.25 3.98122 20.0188 2.75 18.5 2.75H15.5ZM14.25 5.5C14.25 4.80964 14.8096 4.25 15.5 4.25H18.5C19.1904 4.25 19.75 4.80964 19.75 5.5V8.5C19.75 9.19036 19.1904 9.75 18.5 9.75H15.5C14.8096 9.75 14.25 9.19036 14.25 8.5V5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 15.5C2.75 13.9812 3.98122 12.75 5.5 12.75H8.5C10.0188 12.75 11.25 13.9812 11.25 15.5V18.5C11.25 20.0188 10.0188 21.25 8.5 21.25H5.5C3.98122 21.25 2.75 20.0188 2.75 18.5V15.5ZM5.5 14.25C4.80964 14.25 4.25 14.8096 4.25 15.5V18.5C4.25 19.1904 4.80964 19.75 5.5 19.75H8.5C9.19036 19.75 9.75 19.1904 9.75 18.5V15.5C9.75 14.8096 9.19036 14.25 8.5 14.25H5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 12.75C13.9812 12.75 12.75 13.9812 12.75 15.5V18.5C12.75 20.0188 13.9812 21.25 15.5 21.25H18.5C20.0188 21.25 21.25 20.0188 21.25 18.5V15.5C21.25 13.9812 20.0188 12.75 18.5 12.75H15.5ZM14.25 15.5C14.25 14.8096 14.8096 14.25 15.5 14.25H18.5C19.1904 14.25 19.75 14.8096 19.75 15.5V18.5C19.75 19.1904 19.1904 19.75 18.5 19.75H15.5C14.8096 19.75 14.25 19.1904 14.25 18.5V15.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLayoutGrid as ReactComponent };
